module.exports = __webpack_public_path__ + "static/logo-white-5ee55a5da42c85595c3a57c9607fc8ce.png";